// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/bundle." + "algolia-search" + ".js?" + "b20f2266877d107e8488" + "";
};